<template>
    <div class="lb">
        <div class="main ">
            <div class="ani-img showOp"></div>
            <div class="main-bg ">
                <img src="../../assets/template3/temporary1.png" alt="" class="img ">
            </div>
            <div class="ani-img showOp"></div>
            <div class="main-bg">
                <img src="../../assets/template3/temporary2.png" alt="" class="img " style="left: 200px;">
            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'template.leftB-temp3',
    data() {
        return {

        }
    },
    beforeDestroy() {
    },
    methods: {
    },
    mounted() {
    },
}
</script>

<style scoped>
@import '../../css/animation.css';

.lb {
    width: 435px;
    height: 120px;
    padding: 10px 0;
    display: flex;
    position: relative;
    box-sizing: border-box;
    margin: 0 auto;
}

.main {
    display: flex;
}

.ani-img {
    width: 200px;
    height: 140px;
    background: url(../../assets/template3/img-bg.png) no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
}
    .img {
        position: absolute;
        left: 0px;
        margin: 10px 0 0 8px;
        width: 184px;
        height: 120px;
        z-index: 11;
    }

</style>